import React, { Fragment, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import TextField from "@mui/material/TextField";
import { IconButton } from "@mui/material";
import { isEmpty } from "lodash";
import { I18nTranslator, translations } from "utils/i18n";

interface IAppSearch {
  placeholder?: string;
  onChangeText?(searchText: string): void;
}

const AppSearch = React.memo((props: IAppSearch) => {
  const {
    placeholder = I18nTranslator(translations.placeholder.search),
    onChangeText,
  } = props;
  const [searchText, setSearchText] = useState("");

  const onSearch = (searchValue: string) => {
    setSearchText(searchValue);
    onChangeText && onChangeText(searchValue);
  };
  return (
    <TextField
      sx={{ width: "100%", height: 40 }}
      value={searchText}
      placeholder={placeholder}
      onChange={(event) => onSearch(event.target.value)}
      InputProps={{
        sx: {
          height: 40,
        },
        startAdornment: <SearchIcon sx={{ height: 20 }} />,
        endAdornment: (
          <Fragment>
            {!isEmpty(searchText) && (
              <IconButton onClick={() => onSearch("")}>
                <ClearIcon sx={{ height: 20 }} />
              </IconButton>
            )}
          </Fragment>
        ),
      }}
    />
  );
});
export default AppSearch;
